const rootActionPath = 'core/quickLinksTray';

export const QUICK_LINKS_TRAY_VIEW = `${rootActionPath}/VIEW`;
